import { AlertTriangle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';
import { Alert, AlertDescription, AlertTitle } from './ui/alert';

interface ErrorStateProps {
  error: Error | string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorState = ({ error, onRetry, className }: ErrorStateProps) => {
  const errorMessage = typeof error === 'string' ? error : error.message;
  const isNetworkError = errorMessage.toLowerCase().includes('network') || 
                         errorMessage.toLowerCase().includes('fetch');

  return (
    <Alert variant="destructive" className={className}>
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>
        {isNetworkError ? 'Connection Error' : 'Something went wrong'}
      </AlertTitle>
      <AlertDescription className="mt-2">
        <p className="mb-3">
          {isNetworkError 
            ? 'Unable to connect to the server. Please check your internet connection and try again.'
            : errorMessage
          }
        </p>
        {onRetry && (
          <Button
            onClick={onRetry}
            size="sm"
            variant="outline"
            className="bg-background"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Try Again
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
};
